var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.test_status === "not_started",
              expression: "test_status === 'not_started'"
            }
          ],
          staticClass: "row gutter-sm"
        },
        [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row gutter-sm" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t(_vm.getHelper)) +
                    "\n                "
                )
              ]),
              _c(
                "div",
                { staticClass: "col-12 text-weight-medium text-negative" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("helper_general_test")) +
                      "\n                "
                  )
                ]
              ),
              _c("div", { staticClass: "col-12" }, [
                _vm._v(
                  "\n                    " + _vm._s(_vm.$t("questions")) + ": "
                ),
                _c("span", { staticClass: "text-weight-medium" }, [
                  _vm._v(_vm._s(_vm.activity.qty_questions))
                ]),
                _c("br"),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("minimum_score")) +
                    ": "
                ),
                _c("span", { staticClass: "text-weight-medium" }, [
                  _vm._v(_vm._s(_vm.activity.minimum_score))
                ]),
                _c("br"),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("time_to_finish")) +
                    ": "
                ),
                _c("span", { staticClass: "text-weight-medium" }, [
                  _vm._v(_vm._s(_vm.activity.time_to_answer))
                ])
              ])
            ]),
            _vm.realizations.length > 0
              ? _c(
                  "div",
                  { staticClass: "col-12 q-my-md" },
                  [
                    _c(
                      "q-list",
                      { attrs: { dense: "" } },
                      [
                        _c(
                          "q-collapsible",
                          {
                            attrs: {
                              icon: "fal fa-pen",
                              label: _vm.$t("previous_results")
                            }
                          },
                          [
                            _c("q-table", {
                              ref: "table_realizations",
                              staticClass: "shadow-0",
                              attrs: {
                                pagination: _vm.server_pagination,
                                data: _vm.realizations,
                                columns: _vm.columns,
                                "row-key": "id",
                                "no-data-label": _vm.$t("no_data_avaliable"),
                                "no-results-label": _vm.$t("no_results_found"),
                                "loading-label": _vm.$t("loading_data"),
                                "rows-per-page-label": _vm.$t("items_per_page"),
                                "rows-per-page-options": [0],
                                "hide-bottom": ""
                              },
                              on: {
                                "update:pagination": function($event) {
                                  _vm.server_pagination = $event
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function(props) {
                                      return _c(
                                        "q-tr",
                                        { attrs: { props: props } },
                                        _vm._l(props.cols, function(col) {
                                          return _c(
                                            "q-th",
                                            {
                                              key: col.name,
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(_vm.$t(col.label)) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        }),
                                        1
                                      )
                                    }
                                  },
                                  {
                                    key: "body",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "q-tr",
                                          {
                                            attrs: { props: props },
                                            nativeOn: {
                                              click: function($event) {
                                                return _vm.showModalResult(
                                                  props.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "q-td",
                                              {
                                                key: "date",
                                                attrs: { props: props }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      _vm.fDate(props.row.date)
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "q-td",
                                              {
                                                key: "percent",
                                                attrs: { props: props }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      props.row.percent.toFixed(
                                                        2
                                                      )
                                                    ) +
                                                    "%\n                                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "q-td",
                                              {
                                                key: "score",
                                                attrs: { props: props }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      props.row.score.toFixed(2)
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "q-td",
                                              {
                                                key: "test_score",
                                                attrs: { props: props }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      props.row.test_score > 0
                                                        ? props.row.test_score.toFixed(
                                                            2
                                                          )
                                                        : ""
                                                    ) +
                                                    "\n                                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "q-td",
                                              {
                                                key: "status",
                                                attrs: { props: props }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class: _vm.getResultClass(
                                                      props.row.status
                                                    )
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm.getResult(
                                                            props.row.status
                                                          )
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3795701270
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.activity.allowed_to_answer
              ? _c("div", { staticClass: "row gutter-sm justify-end" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-xs-12 col-sm-3",
                      class: _vm.getOrder("cancel")
                    },
                    [
                      _c("q-btn", {
                        staticClass: "full-width",
                        attrs: {
                          color: "tertiary",
                          label: _vm.$t("close"),
                          icon: "far fa-ban"
                        },
                        on: {
                          click: function($event) {
                            return _vm.closeTest()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "col-xs-12 col-sm-3",
                      class: _vm.getOrder("save")
                    },
                    [
                      _c("q-btn", {
                        staticClass: "full-width",
                        attrs: {
                          color: "secondary",
                          label: _vm.$t("start"),
                          icon: "far fa-play"
                        },
                        on: {
                          click: function($event) {
                            return _vm.startTest()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            !_vm.activity.allowed_to_answer
              ? _c("div", { staticClass: "row gutter-sm justify-end" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-xs-12 col-sm-3",
                      class: _vm.getOrder("cancel")
                    },
                    [
                      _c("q-btn", {
                        staticClass: "full-width",
                        attrs: {
                          color: "tertiary",
                          label: _vm.$t("close"),
                          icon: "far fa-ban"
                        },
                        on: {
                          click: function($event) {
                            return _vm.closeTest()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.test_status === "started",
              expression: "test_status === 'started'"
            }
          ],
          staticClass: "row"
        },
        [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "row gutter-sm justify-end" },
              [
                _vm.countdown
                  ? _c("countdown", {
                      attrs: {
                        time: _vm.time_to_answer,
                        "emit-events": true,
                        transform: _vm.transformValues
                      },
                      on: {
                        end: function($event) {
                          return _vm.countdownEnded()
                        },
                        progress: _vm.handleProgress
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(props) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "q-headline",
                                    class: _vm.warning_class
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("question")) +
                                        " " +
                                        _vm._s(_vm.current_question + 1) +
                                        " " +
                                        _vm._s(_vm.$t("of")) +
                                        " " +
                                        _vm._s(_vm.questions.length) +
                                        " -\n\n                            "
                                    ),
                                    _c("span", { class: _vm.warning_class }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.$t("time_left")) +
                                          ": " +
                                          _vm._s(props.hours) +
                                          ":" +
                                          _vm._s(props.minutes) +
                                          ":" +
                                          _vm._s(props.seconds) +
                                          "\n                            "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2106681256
                      )
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("div", { staticClass: "col-12" }, [
            _vm.questions.length > 0
              ? _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "span",
                        {
                          class: _vm.questions[_vm.current_question].error
                            ? "text-negative"
                            : ""
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.current_question + 1) +
                              ") "
                          ),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.questions[_vm.current_question].title
                              )
                            }
                          })
                        ]
                      ),
                      _c(
                        "q-field",
                        {
                          attrs: {
                            error: _vm.questions[_vm.current_question].error,
                            "error-label": _vm.$t("select_one_option")
                          }
                        },
                        [
                          _c("q-option-group", {
                            staticClass: "questions q-mt-xs",
                            attrs: {
                              type: "radio",
                              color: "secondary",
                              options:
                                _vm.questions[_vm.current_question].answers
                            },
                            on: {
                              input: function($event) {
                                _vm.questions[
                                  _vm.current_question
                                ].error = false
                              }
                            },
                            model: {
                              value: _vm.questions[_vm.current_question].answer,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.questions[_vm.current_question],
                                  "answer",
                                  $$v
                                )
                              },
                              expression: "questions[current_question].answer"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _c("div", { staticClass: "row gutter-sm justify-end" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-3" },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      color: "secondary",
                      label: _vm.$t(
                        _vm.current_question + 1 < _vm.questions.length
                          ? "next_question"
                          : "finish_test"
                      ),
                      icon: _vm.$t(
                        _vm.current_question + 1 < _vm.questions.length
                          ? "fal fa-chevron-right"
                          : "fal fa-check"
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveAnswer()
                      }
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.test_status === "finished",
              expression: "test_status === 'finished'"
            }
          ],
          staticClass: "row gutter-sm"
        },
        [
          _c("div", { staticClass: "col-12" }, [
            _c("p", { staticClass: "q-title" }, [
              _vm._v(_vm._s(_vm.$t("test_finished")))
            ]),
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("you_finished_the_test_and_your_result_is")) +
                  ":\n                "
              ),
              _c("span", { class: _vm.getResultClass(_vm.result.status) }, [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t(_vm.getResult(_vm.result.status))))
                ])
              ])
            ]),
            _vm.result.status != 6
              ? _c("p", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("your_score_was") +
                          " " +
                          _vm.result.score +
                          " " +
                          _vm.$t("of") +
                          " " +
                          _vm.result.qty_questions +
                          ", " +
                          _vm.$t("a_total_of") +
                          " " +
                          _vm.result.percent +
                          "% " +
                          _vm.$t("of_right_answers") +
                          "."
                      ) +
                      "\n            "
                  )
                ])
              : _vm._e()
          ]),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row gutter-sm justify-end" }, [
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-3",
                  class: _vm.getOrder("cancel")
                },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      color: "tertiary",
                      label: _vm.$t("close"),
                      icon: "far fa-ban"
                    },
                    on: {
                      click: function($event) {
                        return _vm.closeTest()
                      }
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "90vh"
            }
          },
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_modal = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("result")) +
                        ": " +
                        _vm._s(_vm.activity.type_title) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end question-list" },
                  _vm._l(_vm.realization_questions, function(question, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "q-subheading text-weight-medium q-mb-xs",
                            class: question.is_correct
                              ? "text-positive"
                              : "text-negative",
                            attrs: { id: "qt" + question.id }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(index + 1) +
                                ") "
                            ),
                            _c("span", {
                              domProps: { innerHTML: _vm._s(question.title) }
                            })
                          ]
                        ),
                        _c(
                          "q-field",
                          { attrs: { error: question.error } },
                          [
                            _c("q-option-group", {
                              staticClass: "questions q-mt-xs",
                              class: question.is_correct
                                ? "checkbox-hit"
                                : "checkbox-error",
                              attrs: {
                                type: "radio",
                                options: question.answers,
                                readonly: ""
                              },
                              on: {
                                input: function($event) {
                                  question.error = false
                                }
                              },
                              model: {
                                value: question.answer,
                                callback: function($$v) {
                                  _vm.$set(question, "answer", $$v)
                                },
                                expression: "question.answer"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }